export function clearUserInfo({commit}) {
  commit('resetUserInformation')
  commit('resetCommissionApplyStatus')
  commit('clearToken')
}



// WEBPACK FOOTER //
// ./src/store/actions.js